var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    enableBackground: "new 0 0 64 64",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18 35.121s10-12.226 10-17.121c0-5.514-4.486-10-10-10s-10 4.486-10 10c0 4.896 10 17.121 10 17.121zm0-23.121c3.309 0 6 2.691 6 6 0 2.146-3.14 7.059-6 10.794-2.861-3.732-6-8.644-6-10.794 0-3.309 2.691-6 6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m46 29c-5.514 0-10 4.486-10 10 0 4.896 10 17.121 10 17.121s10-12.225 10-17.121c0-5.514-4.486-10-10-10zm0 20.794c-2.861-3.732-6-8.644-6-10.794 0-3.309 2.691-6 6-6s6 2.691 6 6c0 2.146-3.14 7.059-6 10.794z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12 49c0-1.654 1.346-3 3-3h10c3.859 0 7-3.141 7-7s-3.141-7-7-7h-1v4h1c1.654 0 3 1.346 3 3s-1.346 3-3 3h-10c-3.859 0-7 3.141-7 7s3.141 7 7 7h25v-4h-25c-1.654 0-3-1.346-3-3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m16 16h4v4h-4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m44 37h4v4h-4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoad);
export default __webpack_public_path__ + "static/media/road.57102bed7a4c48156394a3a9e5e27e13.svg";
export { ForwardRef as ReactComponent };